import { EventAddressDto, EventContactInfoDto } from "@app/data/tribeSwaggerApi";
import { Participant } from "@components/StyledCard/types";

export type CreateEvent = {
  event_type_id: number
  event_name: string
  event_address: EventAddressDto
  contact_info?:EventContactInfoDto[]
  start_time: string
  end_time: string
  new_event_tags_names?: string[]
  event_tag_ids?: number[]
  description: string
  avatars_for_deleting?: string[]
  avatars_for_adding: string[]
  invited_user_ids?: number[]
  show_event_in_search: boolean
  is_private: boolean
  has_alcohol: boolean
  send_to_all_users_by_interests: boolean
  is_eighteen_year_limit: boolean
  organizer_id: number
  is_free: boolean
  time_zone: string
  event_price?: number
}
export type SuccessfullyCreateEvent = {
  event_id: number;
  event_photo: string[];
  favorite_event: boolean;
  organizer_photo: string;
  event_type_name: string;
  contact_info: EventContactInfoDto[];
  event_name: string;
  organizer_username: string;
  organizer_id: number;
  event_address: EventAddressDto;
  start_time: string; // ISO дата
  event_duration: string; // ISO 8601 Duration, например "PT1H30M"
  description: string;
  users_who_participants_of_event: Participant[];
  is_private: boolean;
  is_free: boolean;
  is_finished: boolean;
  is_participant: boolean;
  is_want_to_go: boolean;
  is_invited: boolean;
  event_price: number;
}
export type CreateEventBaseInfo = Omit<CreateEvent, "organizer_id" | "time_zone"| "event_price" | "is_free">
export type PaymentData = {is_free: true} | { is_free: false, event_price: number }
export type CreateEventInfo = CreateEventBaseInfo & PaymentData
export const initialState: Partial<CreateEvent> = {}